import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getContractPricesApi,
  putContractPriceApi,
} from "../services/contractprice.api";
import { toast } from "react-toastify";

interface ContractPriceState {
  contractPrices: any[];
  loading: boolean;
  error: string | null;
}

const initialState: ContractPriceState = {
  contractPrices: [],
  loading: false,
  error: null,
};

export const getContractPriceData = createAsyncThunk(
  "getContractPriceData",
  async (params?: { cropId?: number; year?: number; buyerName?: string }) => {
    const response = await getContractPricesApi(params);
    return response.data;
  }
);

export const saveContractPriceData = createAsyncThunk(
  "putContractPrice",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await putContractPriceApi(data);
      return response.data;
    } catch (err: any) {
      if (err.response) {
        console.log("err.response.data:", err.response.data);
        if (err.response.data && err.response.data.errors) {
          return rejectWithValue(err.response.data.errors);
        }
        if (Array.isArray(err.response.data)) {
          return rejectWithValue(err.response.data);
        }
        if (typeof err.response.data === "string") {
          return rejectWithValue([err.response.data]);
        }
      }
      return rejectWithValue([err.message || "Unknown error"]);
    }
  }
);

const contractPriceSlice = createSlice({
  name: "contractprice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContractPriceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContractPriceData.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.contractPrices = payload.length
          ? payload.map((item: any) => ({
              ...item,
              contractPrices: item.periods
                .map(
                  (period: any) =>
                    `${period.buyerName}: $${period.price}/bu - ${period.bushels}bu (${period.contractDate})`
                )
                .join(", "),
            }))
          : payload;
      })
      .addCase(getContractPriceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch contract prices";
      })
      .addCase(saveContractPriceData.fulfilled, () => {
        toast.success("Contract Price saved successfully!");
      })
      .addCase(saveContractPriceData.rejected, (_state, action) => {
        let errorMsg = "Something went wrong. Please try again.";
        // If backend returns an array of error messages
        if (Array.isArray(action.payload) && action.payload.length) {
          errorMsg = action.payload[0];
        } else if (action.error && action.error.message) {
          errorMsg = action.error.message;
        }
        toast.error(errorMsg);
      });
  },
});

export default contractPriceSlice.reducer;